export class RestoreAccountMetricsConfig {
    'restoreAccountId';
    'enabled';
    'destination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "AccountMetricsDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAccountMetricsConfig.attributeTypeMap;
    }
    constructor() {
    }
}
